/* global GOOGLE_API_KEY:true */
import React from "react";
import { connect } from "dva";
import GoogleMapReact from "google-map-react";
import { ShipmentStatus } from "@/utils/enum";
import { middleCoord } from "@/utils/map";
import LiveMarker from "@/components/MapMarkers/LiveMarker/LiveMarker";

const MapMarker = ({ status }) => <LiveMarker status={status} />;

const extraMapRenders = (shipmentData, map, maps) => {
  let directionsService = new maps.DirectionsService();
  let directionsRender = new maps.DirectionsRenderer();
  directionsRender.setMap(map);
  directionsService.route(
    {
      origin: `${shipmentData.pickupAddress.latitude},${shipmentData.pickupAddress.longitude}`,
      destination: `${shipmentData.dropOffAddress.latitude},${shipmentData.dropOffAddress.longitude}`,
      travelMode: "DRIVING",
    },
    function (response, status) {
      if (status === "OK") {
        directionsRender.setDirections(response);
      } else {
        window.alert("Directions request failed due to " + status);
      }
    },
  );
};

const RouteMap = ({ shipmentData, vehicleAndLoadData }) => {
  return (
    <div style={{ marginBottom: 16, marginLeft: 24 }}>
      <div style={{ height: 400 }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: GOOGLE_API_KEY }}
          defaultCenter={{
            lat: middleCoord(shipmentData.pickupAddress.latitude, shipmentData.dropOffAddress.latitude),
            lng: middleCoord(shipmentData.pickupAddress.longitude, shipmentData.dropOffAddress.longitude),
          }}
          defaultZoom={10}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => extraMapRenders(shipmentData, map, maps)}
        >
          {/**
           * Shipment should only ever have one load associated with it at once
           * to map. Checking for 0 lat/long coordinates from the load. Load
           * coordinates are defaulted to 0, 0 so if the location hasn't been
           * updated yet, we want to just use the lat/long of the shipment's
           * pickup location instead.
           */}
          {vehicleAndLoadData && (
            <MapMarker
              key={0}
              lat={
                vehicleAndLoadData?.load?.location?.latitude === 0
                  ? shipmentData.pickupAddress.latitude
                  : vehicleAndLoadData.load.location.latitude
              }
              lng={
                vehicleAndLoadData?.load?.location?.longitude === 0
                  ? shipmentData.pickupAddress.longitude
                  : vehicleAndLoadData?.load.location.longitude
              }
              status={shipmentData.status === ShipmentStatus.Assigned ? "Assigned" : "Posted"}
            />
          )}
        </GoogleMapReact>
      </div>
    </div>
  );
};

export default connect(({ shipmentDetails }) => ({
  shipmentData: shipmentDetails.data,
  vehicleAndLoadData: shipmentDetails.vehicleAndLoadData[0],
}))(RouteMap);
